import { cva, type VariantProps } from "class-variance-authority";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const typographyStyles = cva("", {
  variants: {
    variant: {
      "display-2xl": "text-7xl",
      "display-xl": "text-6xl",
      "display-lg": "text-5xl",
      "display-md": "text-4xl",
      "display-sm": "text-3xl",
      "display-xs": "text-2xl",
      "text-xl": "text-xl",
      "text-lg": "text-lg",
      "text-md": "text-base",
      "text-small": "text-sm",
      "text-xs": "text-xs",
      validationError: "text-error-500 text-sm",
    },
    weight: {
      regular: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    variant: "text-md",
    weight: "regular",
  },
});

interface TypographyProps extends VariantProps<typeof typographyStyles> {
  component?: "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";
  className?: string;
  children: ReactNode | ReactNode[];
  title?: string;
  onClick?: () => void;
}

function Typography({ component = "p", children, variant, weight, className, title, onClick }: TypographyProps) {
  const Component = component;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Component
      className={cn("text-black", typographyStyles({ variant, weight }), className)}
      title={title}
      onClick={handleClick}
    >
      {children}
    </Component>
  );
}

Typography.displayName = "Typography";

export { Typography };
